module.exports = __webpack_public_path__ + "static/media/sidebar_brille.423207fd.jpg";